// extracted by mini-css-extract-plugin
export var dropdownContainer = "_66-5";
export var imageContainer = "_66-4";
export var metricsGrid = "_66-2";
export var productDetailContainer = "_66-1";
export var productListContainer = "_66-0";
export var subscriberTableContainer = "_66-3";